// app/javascript/controllers/industry_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "options", "option", "hiddenInput"]
  static outlets = ["sub-industry"]

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    document.addEventListener("click", this.closeOnClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  toggle(event) {
    event.stopPropagation()
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.optionsTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.optionsTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
  }

  isOpen() {
    return !this.optionsTarget.classList.contains("hidden")
  }

  select(event) {
    const option = event.currentTarget
    const value = option.dataset.value
    const text = option.querySelector("span:first-child").textContent

    this.hiddenInputTarget.value = value
    this.buttonTarget.querySelector("span").textContent = text

    this.optionTargets.forEach(opt => {
      opt.setAttribute('aria-selected', 'false')
      opt.querySelector("span:first-child").classList.remove('font-semibold')
      opt.querySelector("span:first-child").classList.add('font-normal')
      opt.querySelector("span:last-child").classList.add("hidden")
    })

    option.setAttribute('aria-selected', 'true')
    option.querySelector("span:first-child").classList.remove('font-normal')
    option.querySelector("span:first-child").classList.add('font-semibold')
    option.querySelector("span:last-child").classList.remove("hidden")

    // Notify sub-industry controller and reset it
    const subIndustryElement = document.querySelector('[data-controller="sub-industry"]')
    if (subIndustryElement) {
      const subIndustryController = this.application.getControllerForElementAndIdentifier(
        subIndustryElement,
        'sub-industry'
      )
      // Reset sub-industry before updating options
      subIndustryController.resetDropdown()
      subIndustryController.updateOptions(value)
    }

    this.close()
  }
}
